import React from "react";
import ActionButton from "../partials/ActionButton";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import ViewSwitcher from "../ViewSwitcher";
import ViewsMenu from "../header/ViewsMenu";
import { chooseFontColor, imageAddress, textVariableReplacer, translate } from "../../utils/useful";
import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../../utils/Http.services";
import RecordViewerModal from "../../modals/RecordViewerModal";
import { saveAs } from 'file-saver';
import ViewSwitcherWidget from "./ViewSwitcherWidget";
import importedIcons from "../inputs/icons";
import PageBuilderMain from "../../windows/PageBuilderMain";
import ChartWidget from "../widgets/ChartWidget";
import GaugeWidget from "../widgets/GaugeWidget";

class AccoutSettingWidget extends React.Component {
    state = {

        limit: 12,
        skip: 0,
        // pje: [
        //     { name: '1Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '6:30 am', img: "/images/p1.png", img2: "/images/p3.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p2.png", img2: "/images/p1.png" },
        //     { name: '1Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '5:00 pm', img: "/images/p4.png", img2: "/images/p5.png" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '1:30 am', img: "/images/p7.png", img2: "/images/p6.png" },
        //     { name: 'Reading Book', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 pm', img: "/images/p1.png", img2: "" },
        //     { name: 'Attend a business meeting ...', dec: 'Attend a business meeting Attend a business meeting Attend a business meeting Attend a business meeting', time: '10:30 am', img: "/images/p1.png", img2: "/images/p8.png" },

        // ],
        chartOptions: {
            responsive: true,
            aspectRatio: 2 / 1,

        },
        storageData: {
            label: ['test', 'djoiwqjdoiqwjdoi'],
            datasets: [{
                data: [],
                maxValue: 0,
                info: 'MB'
            },],
        },
        category: [
            { bg: "bg-red-300", name: "All", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "bg-red-300", name: "Pending", title: "Attend a business meeting ...", des: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", title1: "Exercise", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#99FFFF", name: "Open", title: "Reading Book", des: "meeting Attend a business meeting", title1: "Painting", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },
            { bg: "#DF73FF", name: "Closed", title: "Attend a business meeting ...", des: "choose the best option and create a pleasant shopping experience. .", title1: "Do somthing", des1: "meeting Attend a business meeting Attend a business meeting Attend a business meeting", },

        ],
        actions: {
            // done: { key: "done", label: '{{lang}}Mark as done', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: this.openEditModal },
            edit: { key: "edit", label: '{{lang}}View / Edit', color: '#000', bgColor: 'linear-gradient(to right, rgba(70, 133, 204, 0.9), rgba(70, 70, 204, 0.9))', function: "openEditModal", icon: importedIcons.edit },
        },
        page: {
            name: 'Account Setting',
            page: [],
        }


    }


    componentDidMount() {

        this.setState({ currentIndex: 0, currentItem: this.state.category[0] })
        this.init()
    }


    init() {

        let data = { ...this.props.data }
        this.setState({ information: data })
        let body = { collection: data.collection }

        this.setState({ isLoading: true })
        console.log('tpppp', this.props)
        let hub = this.props.applet.hub?._id ?? this.props.applet.hub
        HttpServices.request('getMyAccountInfo', { hub }, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult.userInfo) {
                let storageData = this.state.storageData
                storageData.datasets[0].data[0] = fetchResult.userInfo.storage.used
                storageData.datasets[0].maxValue = fetchResult.userInfo.storage.total
                console.log('storageData.datasets[0]', storageData.datasets[0])
                this.setState({ storageData })
            }
        })

    }


    functionsHandler = (type, name, data, extra, info) => {
        // console.log("functionsHandler")
        // console.log(type, name, data, extra)

        // if (!this.props.userView) {

        console.log("functionsHandler", name)

        if (this[name]) {
            this[name](data, extra, info)
        } else {
            if (this.props.functionsHandler) {
                this.props.functionsHandler(type, name, data, extra, info)
            }
        }
        // }
        // else {
        //     console.log("functionsHandlerptop", this.props)
        //     console.log("functionsHandlerstate", this.state)
        // }
    }



    downloadFile = (fullData, extra, info) => {

        // console.log("params", this.props.params)

        // console.log('downloadFile', fullData, extra, info)
        // let file = 'test.png'



        let data = textVariableReplacer(fullData, info?.source, extra?.headers, 'View Record')

        if (Array.isArray(this.props.params)) {
            for (let i = 0; i < this.props.params.length; i++) {
                const param = this.props.params[i];
                data = this.textVariableReplacer(param?.info, data, param.fields, param.label)

            }
        }


        // console.log(data)
        // return


        saveAs(imageAddress(data))

    }




    openWindow = (prop, extra, info) => {
        // console.log('openWindow', prop, extra, info)
        // console.log('this.props.baseUrl', this.props.baseUrl)
        let newLink = this.props.baseUrl.splice(2)
        // return
        newLink.push(info.page)
        newLink.push(prop._id)
        // return
        // console.log('widgettttap', this.props.applet)
        // console.log('newLink', newLink)

        // return
        this.props.changeWindowLink(newLink)


    }

    openEditModal = (prop, extra) => {
        // console.log('this.props.page', this.props.page)

        if (!this.props.userView) {

            let baseUrl = this.props.baseUrl
            let windowData = this.props.windowData
            let data = { ...this.props.data }


            // console.log("baseUrl, ", baseUrl)
            // console.log("windowData, ", windowData)
            // console.log("data, ", data)
            // console.log(this.props.section)
            
            
            this.setState({ currentItem: prop, currentIndex: extra?.index },()=>{
                this.RecordViewerModal.showModal()

            })

        }
        return

        let newLink = this.props.baseUrl?.splice(2)
        if (!newLink) {
            newLink = []
        }
        newLink.push(this.props.page?.key)
        newLink.push(prop._id)
        if (this.props.page?.customEdit) {
            let variables = this.props.variables ?? {}
            variables.currentItem = prop
            this.setState({ variables })
            this.props.changeWindowLink(newLink)
        } else {
            this.setState({ currentItem: null }, () => {
                let variables = this.props.variables ?? {}
                variables.currentItem = prop
                this.setState({ variables })
                if (this.state.relevants?.length > 0) {
                    this.setState({ relevantEdit: true })
                }
                else {
                    this.setState({ edit: true })
                }
                this.setState({ currentItem: prop, currentIndex: extra?.index })
                this.props.changeWindowLink(newLink)
            })
        }
    }





    render() {

        let colors = {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let view = this.props.data?.view ?? {}
        view.type = this.props.data?.type ?? 'table'

        let headersItemModal = null
        let variables = { ...this.props.variables }
        // variables.frameId = this.state.currentRelevantTab ?? this.props.page?._id
        // variables.currentItem = this.state.relevantCurrentItem ?? this.state.currentItem


        return (
            <div className=" w-100 h-100 " >
                <p className="font-size-15 main-c2 weight-600 px-2 pb-1 pt-3" >Storage</p>
                <GaugeWidget
                    value={80}
                    data={this.state.storageData}
                    height={this.props.height}
                    options={this.state.chartOptions}
                    ref={el => this.chart = el}
                />
                {/* <ViewSwitcherWidget viewType={'table'} data={this.props.data} variables={this.props.variables} functionsHandler={this.props.functionsHandler} params={this.props.params} baseUrl={this.props.baseUrl} changeWindowLink={this.props.changeWindowLink} windowData={this.props.windowData} page={this.props.page} width={this.props.width} formPages={this.props.formPages} isMobile={this.props.isMobile} colors={colors} /> */}
                {/* <ViewSwitcher
                    applet={this.state.frame?.applet}
                    data={this.state.data}
                    permissions={this.props.permissions}
                    headers={this.state.frame?.fields}
                    page={this.state.frame}
                    params={this.props.params}
                    actions={this.state.actions}
                    width={this.props.width}
                    functionsHandler={this.functionsHandler}
                    submitForm={this.submitForm}
                    changeValue={this.changeValue}
                    view={view}
                    isLoadingData={this.state.isLoadingData}
                    type={this.props.viewType ?? this.props.view?.type}
                /> */}
                {/* <PageBuilderMain page={this.state.page} permissions={this.props.permissions} userView={this.props.userView} baseUrl={this.props.baseUrl} windowData={this.props.windowData} functionsHandler={this.functionsHandler} setHeader={this.props.setHeader} changeWindow={this.props.changeWindow} params={this.state.params} initData={this.state.initData} type={this.state.type}  ref={el => this.PageBuilderMain = el} width={this.props.width} height={this.props.height} colors={this.props.colors ?? {}} changeWindowLink={this.props.changeWindowLink} pageChangePage={this.props.pageChangePage} applet={this.props.applet} editMode={false} /> */}


            </div >
        )
    }
}



export default AccoutSettingWidget;